<template>
  <section class="gt-page">
    <div class="gt-page-inner">
      <div class="hero gt-card">
        <div>
          <span class="gt-pill">Modulo base</span>
          <h1>Hola, {{ user?.name }}</h1>
          <p class="gt-muted">Este panel carga tu empresa activa, sucursal, permisos, limites y modulos contratados.</p>
        </div>
        <div class="hero-actions">
          <button class="gt-button soft" @click="$router.push('/seleccionar-empresa')">Cambiar empresa</button>
          <button class="gt-button primary" @click="$router.push('/cuenta')">Mi cuenta</button>
        </div>
      </div>

      <div v-if="context" class="gt-grid cols-3 cards">
        <article class="gt-card stat">
          <span>Empresa</span>
          <strong>{{ context.company?.name }}</strong>
          <small>{{ context.subscription?.plan_name || 'Sin plan' }}</small>
        </article>
        <article class="gt-card stat">
          <span>Sucursal</span>
          <strong>{{ context.branch?.name || 'Pendiente de seleccionar' }}</strong>
          <small>{{ context.branches?.length || 0 }} disponibles</small>
        </article>
        <article class="gt-card stat">
          <span>Onboarding</span>
          <strong>{{ context.onboarding?.status || 'sin registro' }}</strong>
          <small>Paso: {{ context.onboarding?.current_step || 'n/a' }}</small>
        </article>
      </div>

      <div class="section-title">
        <h2>Modulos activos</h2>
        <p class="gt-muted">El usuario solo debe navegar lo que su empresa tiene contratado y lo que sus permisos permiten.</p>
      </div>

      <div class="gt-grid cols-3">
        <article v-for="module in modules" :key="module.code" class="module-card gt-card">
          <span class="gt-pill">{{ module.category }}</span>
          <h3>{{ module.name }}</h3>
          <p>{{ module.description }}</p>
          <div v-if="module.code === 'pos'" class="module-actions">
            <button v-if="$store.getters.hasPermission('pos.access')" class="gt-button soft" @click="$router.push('/pv')">Entrar a PV</button>
            <button v-if="$store.getters.hasPermission('pos.access') || $store.getters.hasPermission('comandero.access')" class="gt-button primary" @click="$router.push('/comandero')">Comandero</button>
            <button v-if="$store.getters.hasPermission('hr.manage')" class="gt-button soft" @click="$router.push('/rh')">Recursos humanos</button>
            <button v-if="$store.getters.hasPermission('hr.self')" class="gt-button soft" @click="$router.push('/mi-rh')">Mis horas</button>
            <button v-if="$store.getters.hasPermission('users.manage')" class="gt-button soft" @click="$router.push('/admin/lealtad')">Lealtad</button>
            <button v-if="$store.getters.hasPermission('users.manage')" class="gt-button soft" @click="$router.push('/admin/lealtad/canjes')">Canjes</button>
          </div>
          <button v-else-if="routeForModule(module.code)" class="gt-button soft" @click="$router.push(routeForModule(module.code))">Entrar</button>
        </article>
      </div>

      <div class="section-title">
        <h2>Uso del plan</h2>
      </div>
      <div class="gt-grid cols-3">
        <article v-for="item in usageItems" :key="item.key" class="usage gt-card">
          <span>{{ item.label }}</span>
          <strong>{{ item.used }} / {{ item.limit }}</strong>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DashboardView',
  computed: {
    user() { return this.$store.state.user; },
    context() { return this.$store.state.context; },
    modules() { return this.$store.getters.modules; },
    usageItems() {
      const limits = this.context?.limits || {};
      const usage = this.context?.usage || {};
      return [
        { key: 'branches', label: 'Sucursales', used: usage.branches || 0, limit: limits.branches ?? 'N/A' },
        { key: 'users', label: 'Usuarios', used: usage.users || 0, limit: limits.users ?? 'N/A' },
        { key: 'modules', label: 'Modulos', used: usage.modules || 0, limit: (limits.modules_additional ?? 0) + (this.modules?.filter((m) => m.is_core).length || 0) },
      ];
    },
  },
  methods: {
    routeForModule(code) {
      const routes = { pos: '/pv' };
      return routes[code] || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.hero { padding: 2rem; display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.hero-actions, .module-actions { display: flex; gap: .75rem; flex-wrap: wrap; }
h1 { margin: .75rem 0 .35rem; font-size: clamp(2rem, 4vw, 3.4rem); }
.cards { margin-top: 1.2rem; }
.stat, .module-card, .usage { padding: 1.35rem; }
.stat span, .usage span { color: var(--gt-muted); font-weight: 800; }
.stat strong, .usage strong { display: block; margin-top: .6rem; font-size: 1.5rem; }
.stat small { color: var(--gt-muted); }
.section-title { margin: 2rem 0 1rem; }
.section-title h2 { margin: 0 0 .25rem; }
.module-card h3 { margin: 1rem 0 .45rem; }
.module-card p { color: var(--gt-muted); min-height: 3rem; }
@media (max-width: 760px) { .hero { flex-direction: column; align-items: flex-start; } }
</style>
